import React from 'react';
import {PolIcon} from "components/PolIcon/policon";

/**
 *
 * @param {string} title - The title of the alert.
 * @param {string} message - The message content of the alert.
 * @param {string|false} icon - Optional icon name to display in the alert. If false, no icon will be shown. If not provided, a default icon based on the alert type will be used.
 * @param {React.ReactNode} children - Optional additional content to display within the alert.
 * @param {'warning' | 'error' | 'success' | 'info' | 'neutral'} type - The type of alert, which determines the background color.
 * @returns {JSX.Element} The Alert component.
 */

export default function Alert({title, message, icon, children, type = 'neutral'}) {
    const backgroundColors = {
        warning: '#ffc107',
        error: '#dc3545',
        success: '#28a745',
        info: '#17a2b8',
        neutral: '#6c757d'
    };
    const backgroundColor = backgroundColors[type] || backgroundColors.neutral;

    const icons = {
        warning: 'warning',
    };
    const alertIcon = icon ?? icons[type];

    return (
        <div className="d-flex justify-content-center">
            <div className="d-inline-block p-3"
                 style={{borderRadius: 4, background: backgroundColor}}>
                <p style={{fontSize: '1.25rem', marginBottom: '0.5rem'}}>
                    {alertIcon && <PolIcon icon={alertIcon}/>} {title}</p>
                <p>{message}</p>
                {children}
            </div>
        </div>
    )
}
